import { render, staticRenderFns } from "./TodoListTasks.vue?vue&type=template&id=4b8b018a&scoped=true&"
import script from "./TodoListTasks.vue?vue&type=script&lang=js&"
export * from "./TodoListTasks.vue?vue&type=script&lang=js&"
import style0 from "./TodoListTasks.vue?vue&type=style&index=0&id=4b8b018a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8b018a",
  null
  
)

export default component.exports